import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { CurrencyProvider } from "./contexts/CurrencyContext";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import HomePage from "./pages/HomePage";
import FeaturesPage from "./pages/FeaturesPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import BlogArticle from "./pages/BlogArticle";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import DPAPage from "./pages/DPAPage";
import WelcomePage from "./pages/WelcomePage";
import BestCRMPlumbersUK from "./pages/BestCRMPlumbersUK";
import BestCRMElectriciansUK from "./pages/BestCRMElectriciansUK";
import BestCRMDentistsUK from "./pages/BestCRMDentistsUK";
import BestCRMHairSalonsUK from "./pages/BestCRMHairSalonsUK";
import BestCRMRoofersUK from "./pages/BestCRMRoofersUK";
import BestCRMEstateAgentsUK from "./pages/BestCRMEstateAgentsUK";
import BestCRMLandscapersUK from "./pages/BestCRMLandscapersUK";
import BestCRMHVACUK from "./pages/BestCRMHVACUK";
import BestCRMAutoRepairUK from "./pages/BestCRMAutoRepairUK";
import BestCRMAccountantsUK from "./pages/BestCRMAccountantsUK";
import BestCRMChiropractorsUK from "./pages/BestCRMChiropractorsUK";
import BestCRMPersonalTrainersUK from "./pages/BestCRMPersonalTrainersUK";
import BestCRMCleaningServicesUK from "./pages/BestCRMCleaningServicesUK";
import BestCRMPestControlUK from "./pages/BestCRMPestControlUK";
import BestCRMVeterinaryUK from "./pages/BestCRMVeterinaryUK";
import BestCRMPhotographersUK from "./pages/BestCRMPhotographersUK";
import BestCRMITServicesUK from "./pages/BestCRMITServicesUK";
import BestCRMLawnCareUK from "./pages/BestCRMLawnCareUK";
import BestCRMMassageTherapyUK from "./pages/BestCRMMassageTherapyUK";
import BestCRMMarketingAgencyUK from "./pages/BestCRMMarketingAgencyUK";
import BestCRMHandymanUK from "./pages/BestCRMHandymanUK";
import BestCRMPaintingUK from "./pages/BestCRMPaintingUK";
import BestCRMTutoringUK from "./pages/BestCRMTutoringUK";
import BestCRMPetGroomingUK from "./pages/BestCRMPetGroomingUK";
import BestCRMLocksmithsUK from "./pages/BestCRMLocksmithsUK";
import BestCRMTreeServiceUK from "./pages/BestCRMTreeServiceUK";
import BestCRMSolarInstallationUK from "./pages/BestCRMSolarInstallationUK";
import BestCRMInsuranceAgencyUK from "./pages/BestCRMInsuranceAgencyUK";
import BestCRMMovingCompanyUK from "./pages/BestCRMMovingCompanyUK";
import BestCRMCateringUK from "./pages/BestCRMCateringUK";
import BestCRMWindowCleaningUK from "./pages/BestCRMWindowCleaningUK";
import BestCRMAutoDetailingUK from "./pages/BestCRMAutoDetailingUK";
import BestCRMTowingServiceUK from "./pages/BestCRMTowingServiceUK";
import BestCRMMartialArtsUK from "./pages/BestCRMMartialArtsUK";
import BestCRMDanceStudioUK from "./pages/BestCRMDanceStudioUK";
import BestCRMSpaServicesUK from "./pages/BestCRMSpaServicesUK";
import BestCRMOptometryUK from "./pages/BestCRMOptometryUK";
import NotFoundPage from "./pages/NotFoundPage";
import IndustriesPage from "./pages/IndustriesPage";
import HighStreetBusinesses from "./pages/HighStreetBusinesses";
import AppointmentBusinesses from "./pages/AppointmentBusinesses";
import HomeServices from "./pages/HomeServices";
import ProfessionalServices from "./pages/ProfessionalServices";
import { initGA4, initFacebookPixel, trackPageView } from "./utils/analytics";

// Industry Pages
import TowingService from "./pages/industries/TowingService";
import AutoBodyPainting from "./pages/industries/AutoBodyPainting";
import Plumber from "./pages/industries/Plumber";
import Electrician from "./pages/industries/Electrician";
import HVAC from "./pages/industries/HVAC";
import RealEstateAgent from "./pages/industries/RealEstateAgent";
import HairSalon from "./pages/industries/HairSalon";
import Dental from "./pages/industries/Dental";
import PersonalTrainer from "./pages/industries/PersonalTrainer";
import Landscaping from "./pages/industries/Landscaping";
import AutomotiveRepair from "./pages/industries/AutomotiveRepair";
import Roofing from "./pages/industries/Roofing";
import AccountingFirm from "./pages/industries/AccountingFirm";
import Chiropractor from "./pages/industries/Chiropractor";
import MarketingAgency from "./pages/industries/MarketingAgency";
import PersonalInjuryAttorney from "./pages/industries/PersonalInjuryAttorney";

// Special Offer Pages
import PlumberOffer from "./pages/offers/PlumberOffer";
import ElectricianOffer from "./pages/offers/ElectricianOffer";
import RooferOffer from "./pages/offers/RooferOffer";
import HvacOffer from "./pages/offers/HvacOffer";
import CarpenterOffer from "./pages/offers/CarpenterOffer";
import LandscaperOffer from "./pages/offers/LandscaperOffer";
import PainterOffer from "./pages/offers/PainterOffer";
import HVACOffer from "./pages/offers/HVACOffer";
import RoofingOffer from "./pages/offers/RoofingOffer";
import DentalOffer from "./pages/offers/DentalOffer";
import Veterinary from "./pages/industries/Veterinary";
import CleaningService from "./pages/industries/CleaningService";
import PestControl from "./pages/industries/PestControl";
import Locksmith from "./pages/industries/Locksmith";
import MassageTherapy from "./pages/industries/MassageTherapy";
import HomeInspector from "./pages/industries/HomeInspector";
import InsuranceAgency from "./pages/industries/InsuranceAgency";
import Florist from "./pages/industries/Florist";
import Catering from "./pages/industries/Catering";
import PetGrooming from "./pages/industries/PetGrooming";
import ApplianceRepair from "./pages/industries/ApplianceRepair";
import GeneralContractor from "./pages/industries/GeneralContractor";
import CarpetCleaning from "./pages/industries/CarpetCleaning";
import MovingCompany from "./pages/industries/MovingCompany";
import Photography from "./pages/industries/Photography";
import WindowCleaning from "./pages/industries/WindowCleaning";
import JunkRemoval from "./pages/industries/JunkRemoval";
import PoolService from "./pages/industries/PoolService";
import Handyman from "./pages/industries/Handyman";
import TreeService from "./pages/industries/TreeService";
import PressureWashing from "./pages/industries/PressureWashing";
import LawnCare from "./pages/industries/LawnCare";
import GarageDoor from "./pages/industries/GarageDoor";
import Painting from "./pages/industries/Painting";
import ITServices from "./pages/industries/ITServices";
import AutoDetailing from "./pages/industries/AutoDetailing";
import WeddingPlanner from "./pages/industries/WeddingPlanner";
import SolarInstallation from "./pages/industries/SolarInstallation";
import DogTraining from "./pages/industries/DogTraining";
import YogaStudio from "./pages/industries/YogaStudio";
import MartialArts from "./pages/industries/MartialArts";
import MusicLessons from "./pages/industries/MusicLessons";
import Tutoring from "./pages/industries/Tutoring";
import MedspaAesthetics from "./pages/industries/MedspaAesthetics";
import BikeShop from "./pages/industries/BikeShop";
import PhysicalTherapy from "./pages/industries/PhysicalTherapy";
import Childcare from "./pages/industries/Childcare";
import SeniorCare from "./pages/industries/SeniorCare";
import DanceStudio from "./pages/industries/DanceStudio";
import Optometry from "./pages/industries/Optometry";
import TattooShop from "./pages/industries/TattooShop";
import NailSalon from "./pages/industries/NailSalon";
import SpaServices from "./pages/industries/SpaServices";
import Gymnastics from "./pages/industries/Gymnastics";
import SwimmingLessons from "./pages/industries/SwimmingLessons";
import Counseling from "./pages/industries/Counseling";
import Podiatry from "./pages/industries/Podiatry";
import BarberShop from "./pages/industries/BarberShop";
import TennisLessons from "./pages/industries/TennisLessons";
import GolfLessons from "./pages/industries/GolfLessons";
import BoatRepair from "./pages/industries/BoatRepair";
import RVRepair from "./pages/industries/RVRepair";
import MotorcycleRepair from "./pages/industries/MotorcycleRepair";
import Firewood from "./pages/industries/Firewood";
import Upholstery from "./pages/industries/Upholstery";
import Acupuncture from "./pages/industries/Acupuncture";
import Dermatology from "./pages/industries/Dermatology";
import PetSitting from "./pages/industries/PetSitting";
import FenceInstallation from "./pages/industries/FenceInstallation";
import ChimneySweep from "./pages/industries/ChimneySweep";
import DeckBuilder from "./pages/industries/DeckBuilder";
import SepticService from "./pages/industries/SepticService";
import GutterCleaning from "./pages/industries/GutterCleaning";
import TaxPreparation from "./pages/industries/TaxPreparation";
import PropertyManagement from "./pages/industries/PropertyManagement";

// Page tracking component
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
}

function App() {
  // Initialize analytics on app load
  useEffect(() => {
    // GA4 and Google Ads are loaded via index.html script tags
    // Just initialize Facebook Pixel if configured
    const fbPixelId = process.env.REACT_APP_FB_PIXEL_ID;
    
    if (fbPixelId) {
      initFacebookPixel(fbPixelId);
    } else {
      console.log('ℹ️ Facebook Pixel not configured (optional)');
    }
    
    // Verify gtag is loaded
    if (window.gtag) {
      console.log('✅ Google Analytics tracking active');
    }
  }, []);
  
  return (
    <HelmetProvider>
      <CurrencyProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <PageTracker />
            <Header />
            <main>
              <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/dpa" element={<DPAPage />} />
              <Route path="/welcome" element={<WelcomePage />} />
              
              {/* Special Offer Pages */}
              <Route path="/offers/plumber-lifetime-upgrade" element={<PlumberOffer />} />
              <Route path="/offers/electrician-lifetime-upgrade" element={<ElectricianOffer />} />
              <Route path="/offers/roofer-lifetime-upgrade" element={<RooferOffer />} />
              <Route path="/offers/hvac-lifetime-upgrade" element={<HvacOffer />} />
              <Route path="/offers/carpenter-lifetime-upgrade" element={<CarpenterOffer />} />
              <Route path="/offers/landscaper-lifetime-upgrade" element={<LandscaperOffer />} />
              <Route path="/offers/painter-lifetime-upgrade" element={<PainterOffer />} />
              <Route path="/offers/hvac-lifetime-upgrade" element={<HVACOffer />} />
              <Route path="/offers/roofing-lifetime-upgrade" element={<RoofingOffer />} />
              <Route path="/offers/dental-lifetime-upgrade" element={<DentalOffer />} />
              
              <Route path="/best-crm-for-plumbers-uk" element={<BestCRMPlumbersUK />} />
              <Route path="/best-crm-for-electricians-uk" element={<BestCRMElectriciansUK />} />
              <Route path="/best-crm-for-dentists-uk" element={<BestCRMDentistsUK />} />
              <Route path="/best-crm-for-hair-salons-uk" element={<BestCRMHairSalonsUK />} />
              <Route path="/best-crm-for-roofers-uk" element={<BestCRMRoofersUK />} />
              <Route path="/best-crm-for-estate-agents-uk" element={<BestCRMEstateAgentsUK />} />
              <Route path="/best-crm-for-landscapers-uk" element={<BestCRMLandscapersUK />} />
              <Route path="/best-crm-for-hvac-uk" element={<BestCRMHVACUK />} />
              <Route path="/best-crm-for-auto-repair-uk" element={<BestCRMAutoRepairUK />} />
              <Route path="/best-crm-for-accountants-uk" element={<BestCRMAccountantsUK />} />
              <Route path="/best-crm-for-chiropractors-uk" element={<BestCRMChiropractorsUK />} />
              <Route path="/best-crm-for-personal-trainers-uk" element={<BestCRMPersonalTrainersUK />} />
              <Route path="/best-crm-for-cleaning-services-uk" element={<BestCRMCleaningServicesUK />} />
              <Route path="/best-crm-for-pest-control-uk" element={<BestCRMPestControlUK />} />
              <Route path="/best-crm-for-vets-uk" element={<BestCRMVeterinaryUK />} />
              <Route path="/best-crm-for-photographers-uk" element={<BestCRMPhotographersUK />} />
              <Route path="/best-crm-for-it-services-uk" element={<BestCRMITServicesUK />} />
              <Route path="/best-crm-for-lawn-care-uk" element={<BestCRMLawnCareUK />} />
              <Route path="/best-crm-for-massage-therapists-uk" element={<BestCRMMassageTherapyUK />} />
              <Route path="/best-crm-for-marketing-agencies-uk" element={<BestCRMMarketingAgencyUK />} />
              <Route path="/best-crm-for-handyman-uk" element={<BestCRMHandymanUK />} />
              <Route path="/best-crm-for-painters-uk" element={<BestCRMPaintingUK />} />
              <Route path="/best-crm-for-tutors-uk" element={<BestCRMTutoringUK />} />
              <Route path="/best-crm-for-pet-groomers-uk" element={<BestCRMPetGroomingUK />} />
              <Route path="/best-crm-for-locksmiths-uk" element={<BestCRMLocksmithsUK />} />
              <Route path="/best-crm-for-tree-service-uk" element={<BestCRMTreeServiceUK />} />
              <Route path="/best-crm-for-solar-installers-uk" element={<BestCRMSolarInstallationUK />} />
              <Route path="/best-crm-for-insurance-agencies-uk" element={<BestCRMInsuranceAgencyUK />} />
              <Route path="/best-crm-for-moving-companies-uk" element={<BestCRMMovingCompanyUK />} />
              <Route path="/best-crm-for-caterers-uk" element={<BestCRMCateringUK />} />
              <Route path="/best-crm-for-window-cleaners-uk" element={<BestCRMWindowCleaningUK />} />
              <Route path="/best-crm-for-auto-detailers-uk" element={<BestCRMAutoDetailingUK />} />
              <Route path="/best-crm-for-towing-companies-uk" element={<BestCRMTowingServiceUK />} />
              <Route path="/best-crm-for-martial-arts-uk" element={<BestCRMMartialArtsUK />} />
              <Route path="/best-crm-for-dance-studios-uk" element={<BestCRMDanceStudioUK />} />
              <Route path="/best-crm-for-spas-uk" element={<BestCRMSpaServicesUK />} />
              <Route path="/best-crm-for-optometrists-uk" element={<BestCRMOptometryUK />} />
              <Route path="/industries" element={<IndustriesPage />} />
              <Route path="/industries/high-street" element={<HighStreetBusinesses />} />
              <Route path="/industries/appointment-based" element={<AppointmentBusinesses />} />
              <Route path="/industries/home-services" element={<HomeServices />} />
              <Route path="/industries/professional-services" element={<ProfessionalServices />} />
              
              {/* Industry Pages */}
              <Route path="/industries/towing-service" element={<TowingService />} />
              <Route path="/industries/auto-body-painting" element={<AutoBodyPainting />} />
              <Route path="/industries/plumber" element={<Plumber />} />
              <Route path="/industries/electrician" element={<Electrician />} />
              <Route path="/industries/hvac" element={<HVAC />} />
              <Route path="/industries/real-estate-agent" element={<RealEstateAgent />} />
              <Route path="/industries/hair-salon" element={<HairSalon />} />
              <Route path="/industries/dental" element={<Dental />} />
              <Route path="/industries/personal-trainer" element={<PersonalTrainer />} />
              <Route path="/industries/landscaping" element={<Landscaping />} />
              <Route path="/industries/automotive-repair" element={<AutomotiveRepair />} />
              <Route path="/industries/roofing" element={<Roofing />} />
              <Route path="/industries/accounting-firm" element={<AccountingFirm />} />
              <Route path="/industries/chiropractor" element={<Chiropractor />} />
              <Route path="/industries/marketing-agency" element={<MarketingAgency />} />
              <Route path="/industries/personal-injury-attorney" element={<PersonalInjuryAttorney />} />
              <Route path="/industries/veterinary" element={<Veterinary />} />
              <Route path="/industries/cleaning-service" element={<CleaningService />} />
              <Route path="/industries/pest-control" element={<PestControl />} />
              <Route path="/industries/locksmith" element={<Locksmith />} />
              <Route path="/industries/massage-therapy" element={<MassageTherapy />} />
              <Route path="/industries/home-inspector" element={<HomeInspector />} />
              <Route path="/industries/insurance-agency" element={<InsuranceAgency />} />
              <Route path="/industries/florist" element={<Florist />} />
              <Route path="/industries/catering" element={<Catering />} />
              <Route path="/industries/pet-grooming" element={<PetGrooming />} />
              <Route path="/industries/appliance-repair" element={<ApplianceRepair />} />
              <Route path="/industries/general-contractor" element={<GeneralContractor />} />
              <Route path="/industries/carpet-cleaning" element={<CarpetCleaning />} />
              <Route path="/industries/moving-company" element={<MovingCompany />} />
              <Route path="/industries/photography" element={<Photography />} />
              <Route path="/industries/window-cleaning" element={<WindowCleaning />} />
              <Route path="/industries/junk-removal" element={<JunkRemoval />} />
              <Route path="/industries/pool-service" element={<PoolService />} />
              <Route path="/industries/handyman" element={<Handyman />} />
              <Route path="/industries/tree-service" element={<TreeService />} />
              <Route path="/industries/pressure-washing" element={<PressureWashing />} />
              <Route path="/industries/lawn-care" element={<LawnCare />} />
              <Route path="/industries/garage-door" element={<GarageDoor />} />
              <Route path="/industries/painting" element={<Painting />} />
              <Route path="/industries/it-services" element={<ITServices />} />
              <Route path="/industries/auto-detailing" element={<AutoDetailing />} />
              <Route path="/industries/wedding-planner" element={<WeddingPlanner />} />
              <Route path="/industries/solar-installation" element={<SolarInstallation />} />
              <Route path="/industries/dog-training" element={<DogTraining />} />
              <Route path="/industries/yoga-studio" element={<YogaStudio />} />
              <Route path="/industries/martial-arts" element={<MartialArts />} />
              <Route path="/industries/music-lessons" element={<MusicLessons />} />
              <Route path="/industries/tutoring" element={<Tutoring />} />
              <Route path="/industries/medspa-aesthetics" element={<MedspaAesthetics />} />
              <Route path="/industries/bike-shop" element={<BikeShop />} />
              <Route path="/industries/physical-therapy" element={<PhysicalTherapy />} />
              <Route path="/industries/childcare" element={<Childcare />} />
              <Route path="/industries/senior-care" element={<SeniorCare />} />
              <Route path="/industries/dance-studio" element={<DanceStudio />} />
              <Route path="/industries/optometry" element={<Optometry />} />
              <Route path="/industries/tattoo-shop" element={<TattooShop />} />
              <Route path="/industries/nail-salon" element={<NailSalon />} />
              <Route path="/industries/spa-services" element={<SpaServices />} />
              <Route path="/industries/gymnastics" element={<Gymnastics />} />
              <Route path="/industries/swimming-lessons" element={<SwimmingLessons />} />
              <Route path="/industries/counseling" element={<Counseling />} />
              <Route path="/industries/podiatry" element={<Podiatry />} />
              <Route path="/industries/barber-shop" element={<BarberShop />} />
              <Route path="/industries/tennis-lessons" element={<TennisLessons />} />
              <Route path="/industries/golf-lessons" element={<GolfLessons />} />
              <Route path="/industries/boat-repair" element={<BoatRepair />} />
              <Route path="/industries/rv-repair" element={<RVRepair />} />
              <Route path="/industries/motorcycle-repair" element={<MotorcycleRepair />} />
              <Route path="/industries/firewood" element={<Firewood />} />
              <Route path="/industries/upholstery" element={<Upholstery />} />
              <Route path="/industries/acupuncture" element={<Acupuncture />} />
              <Route path="/industries/dermatology" element={<Dermatology />} />
              <Route path="/industries/pet-sitting" element={<PetSitting />} />
              <Route path="/industries/fence-installation" element={<FenceInstallation />} />
              <Route path="/industries/chimney-sweep" element={<ChimneySweep />} />
              <Route path="/industries/deck-builder" element={<DeckBuilder />} />
              <Route path="/industries/septic-service" element={<SepticService />} />
              <Route path="/industries/gutter-cleaning" element={<GutterCleaning />} />
              <Route path="/industries/tax-preparation" element={<TaxPreparation />} />
              <Route path="/industries/property-management" element={<PropertyManagement />} />
              
              {/* 404 - Catch all undefined routes */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
        </BrowserRouter>
      </div>
    </CurrencyProvider>
    </HelmetProvider>
  );
}

export default App;